import React from "react";
import PageSeo from "../components/PageSeo";
import { SUPPORT_EMAIL, absoluteUrl } from "../seo/siteData";

const DeleteAccount = () => {
  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Delete Account - Zarkit",
      url: absoluteUrl("/delete-account"),
      description:
        "Learn how to request deletion of your Zarkit account and associated personal data.",
    },
  ];

  return (
    <>
      <PageSeo
        title="Delete Account"
        description="Request deletion of your Zarkit account and personal data using your registered email or mobile number."
        path="/delete-account"
        keywords="delete Zarkit account, Zarkit account deletion, remove delivery app account"
        structuredData={structuredData}
      />

      <div style={styles.wrapper}>
        <div style={styles.container}>
          <h1 style={styles.heading}>Account Deletion Policy</h1>

          <p style={styles.text}>
            To permanently delete your account, contact our support team at{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`} style={styles.link}>
              {SUPPORT_EMAIL}
            </a>{" "}
            with your registered email or mobile number.
          </p>

          <p style={styles.text}>
            Account deletion requests are processed within{" "}
            <strong>7-30 working days</strong>, depending on verification and
            legal requirements.
          </p>

          <p style={styles.text}>
            When your account is deleted, personal information such as your
            name, email, phone number, and usage history is permanently
            removed. Some anonymized or aggregated data may be retained for
            analytics or legal compliance purposes.
          </p>

          <p style={styles.text}>
            Once deleted, your account and personal data will be permanently
            removed and <strong>cannot be recovered</strong>.
          </p>

          <p style={styles.text}>
            For any questions or assistance, please contact{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`} style={styles.link}>
              {SUPPORT_EMAIL}
            </a>.
          </p>

          <a href="/" style={styles.backButton}>
            Back to Home
          </a>
        </div>
      </div>
    </>
  );
};

const styles = {
  wrapper: {
    padding: "10px",
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    width: "100%",
    maxWidth: "600px",
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    fontFamily: "Arial, sans-serif",
    color: "#333",
    lineHeight: "1.6",
    boxSizing: "border-box",
  },
  heading: {
    fontSize: "2rem",
    color: "#2c3e50",
    marginBottom: "20px",
    textAlign: "center",
  },
  text: {
    fontSize: "1rem",
    marginBottom: "15px",
  },
  link: {
    color: "#3498db",
    textDecoration: "none",
    wordBreak: "break-all",
  },
  backButton: {
    display: "inline-block",
    marginTop: "20px",
    padding: "12px 18px",
    backgroundColor: "#3498db",
    color: "#fff",
    borderRadius: "6px",
    textDecoration: "none",
    textAlign: "center",
    fontWeight: "bold",
  },
};

export default DeleteAccount;
